export const ConfirmNoGSTINDialog = {
  'Update now': _TL_('Update now'),
  Dismiss: _TL_('Dismiss'),
  'No GSTIN on file': _TL_('No GSTIN on file'),
  'If you need tax invoices for your account, please go back and enter your Goods and Services Tax Identification Number (GSTIN). Without a GSTIN, we can’t provide tax invoices for you.': _TL_('If you need tax invoices for your account, please go back and enter your Goods and Services Tax Identification Number (GSTIN). Without a GSTIN, we can’t provide tax invoices for you.'),
};
